<template>
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="var(--primary-color)"
      :is-full-page="fullPage"
    ></loading>
    <div class="grid">
      <div class="col-12">
        <div class="card">
          <Toast />
          <DataTable
            :loading="loading"
            ref="dt"
            :lazy="true"
            :totalRecords="totalRecords"
            :paginator="true"
            :value="products"
            v-model:selection="selectedProducts"
            :dataKey="columns[0]"
            :rows="limit"
            :filters="filters"
            @page="onPage($event)"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 25, totalRecords]"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            responsiveLayout="scroll"
            style="font-size: 12px"
            :rowHover="true"
            showGridlines
          >
            <template #empty>
              <b style="text-align: center">No records found.</b>
            </template>
            <template #header>
              <div
                class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
              >
                <h5><b>Feedback List</b></h5>
                <div class="flex align-items-center gap-3">
                 
                  <Button
                    icon="pi pi-upload"
                    class="p-button-rounded p-button-help"
                    v-tooltip.bottom="'Export CSV'"
                    @click="exportCSV($event)"
                  />
                  <span>Total : {{ totalRecords }}</span>
                </div>
              </div>
              <div
                class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3"
              >
                <!-- Filters Section -->
                <div class="flex flex-wrap gap-3">
                  <!-- Name Filter -->
                  <div class="field w-auto">
                    <span class="p-float-label">
                      <InputText
                        type="text"
                        v-model="search_name"
                        v-tooltip.bottom="'search'"
                      />
                      <label for="name">Search</label>
                    </span>
                  </div>
                  <Button
                    icon="pi pi-search"
                    @click="search(1)"
                    class="p-button-rounded p-button-primary"
                    v-tooltip.bottom="'Search'"
                  />
                  <Button
                    icon="pi pi-refresh"
                    class="p-button-rounded p-button-danger"
                    v-tooltip.bottom="'Refresh'"
                    @click="search(2)"
                  />
                </div>
              </div>
            </template>
            <!-- <Column v-for="(col,index) in columns" :field="col" :header="col.toUpperCase()" :key="index"></Column> -->
            <!-- <Column selectionMode="multiple" headerStyle="width: 3rem"></Column> -->
            
            
            <Column header="Sr No" style="max-width: 2rem">
              <template #body="{ index }">
                <span v-if="page_no == 1">{{ +index + +1 }}</span>
                <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
              </template>
            </Column>
            <Column header="Title" style="max-width: 2rem" :field="columns[1]">
            <template #body="{ data }">
              {{ data.title }}
            </template>
            </Column>
            <Column header="Name" style="max-width: 5rem" :field="columns[2]">
            <template #body="{ data }">
              {{ data.fullName }}
            </template>
            </Column>
            <Column header="Email" style="max-width: 3rem" :field="columns[3]">
            <template #body="{ data }">
              {{ data.email }}
            </template>
            </Column>
            <Column header="Mobile" style="max-width: 3rem" :field="columns[4]">
            <template #body="{ data }">
              {{ data.mobile }}
            </template>
            </Column>
            <!-- <Column header="State" style="max-width: 3rem" :field="columns[1]">
            <template #body="{ data }">
              {{ data.state_name }}
            </template>
            </Column> -->
            <Column header="District" style="max-width: 3rem" :field="columns[15]">
            <template #body="{ data }">
              {{ data.district_name }}
            </template>
            </Column>
            <Column header="Tehsil" style="max-width: 3rem" :field="columns[8]">
            <template #body="{ data }">
              {{ data.tehsil }}
            </template>
            </Column>
            <Column header="Town/Village" style="max-width: 3rem" :field="columns[9]">
            <template #body="{ data }">
              {{ data.townVillage }}
            </template>
            </Column>
            
            <Column header="House/Flat" style="max-width: 3rem" :field="columns[10]">
            <template #body="{ data }">
              {{ data.houseFlat }}
            </template>
            </Column>
            <Column header="Road/Street" style="max-width: 3rem" :field="columns[11]">
            <template #body="{ data }">
              {{ data.roadStreet }}
            </template>
            </Column>
            
            <Column header="Pin" style="max-width: 2rem" :field="columns[12]">
            <template #body="{ data }">
              {{ data.pin }}
            </template>
            </Column>
            <Column header="Feedback" style="max-width: 5rem" :field="columns[13]">
            <template #body="{ data }">
              {{ data.feedback }}
            </template>
            </Column>
            
            
          </DataTable>
          
        </div>
      </div>
    </div>
  </template>
  <script>
  import { FilterMatchMode } from "primevue/api";
  import ProductService from "../service/ProductService";
  //import FormNewsMaster from "@/components/FormNewsMaster";
  //import * as Survey from "survey-vue";
  // import axios from "axios";
  import apis from "@/apis";
  import axios from "axios";
  export default {
    data() {
      return {
        productService: null,
        search_name: "",
        page_no: 1,
        isLoading: false,
        isLoadingModel: false,
        loading: false,
        fullPage: true,
        file_attachment: "",
        status_dropdownItems: [
          { name: "Active", value: "1" },
          { name: "InActive", value: "2" },
          { name: "Deleted", value: "3" },
        ],
        status: null,
        products: [],
        productDialog: false,
        deleteProductDialog: false,
        deleteProductsDialog: false,
        lazyParams: {},
        product: {},
        selectedProducts: null,
        filters: {},
        offset: 1,
        selectstatus: { name: "Active", value: "Active" },
        selectstatus2: { name: "Motivational", value: "Motivational" },
        limit: 10,
        columns: [],
        head: [
          "Data Usages",
          "Network Connectivity",
          "Students",
          "Teachers",
          "Student Registration",
          "News Master",
          "Government Panel",
          "Feedback Master",
          "User Queries",
          "Schemes Master",
          "Notice Master",
          "Subject Master",
          "Teacher Schedule Master",
          "Teacher Schedule DE Master",
          "Query Types Master",
          "Sub Query Types Master",
          "Admin Users",
          "Application Roles",
          "Departments",
          "Cast Master",
          "Year Master",
          "District Master",
          "Student Attendance",
          "Student Document",
          "Teachers",
          "Radical ids",
          "Subject Topics",
          "Query Comments",
          "Student Submit Answers",
          "Mock Tests",
          "Mock Test Papers",
          "Mock Test Results",
          "Video",
          "Syllabus",
          "Course",
        ],
        pageno: 1,
        submitted: false,
        totalRecords: 0,
        id: "",
        statuses: [
          { label: "INSTOCK", value: "instock" },
          { label: "LOWSTOCK", value: "lowstock" },
          { label: "OUTOFSTOCK", value: "outofstock" },
        ],
      };
    },
    async created() {
      this.productService = new ProductService();
      this.initFilters();
    },
    async mounted() {
      // this.productService.getProducts().then(data => this.products = data);
      this.id = this.$route.params.id;
      this.lazyParams = {
        first: 0,
        rows: this.limit,
        sortField: null,
        sortOrder: null,
        filters: this.filters,
      };
      if (this.totalRecords == 0) {
        await this.get_count();
      }
      await this.get_list();
      //alert(this.id);
    },
    watch: {
      async $route() {
        this.columns = [];
        this.totalRecords = 0;
        this.id = this.$route.params.id;
        if (this.id) {
          await this.get_count();
          this.get_list();
        }
      },
    },
    methods: {
      async search(count) {
        if (count == 2) {
          this.search_name = "";
        }
        await this.get_list();
        await this.get_count();
      },
      handleFileUpload() {
        this.file_attachment = this.$refs.file_attachment.files[0];
        //alert(this.$refs.file_attachment.files[0].name);
      },
      async onPage(event) {
        this.lazyParams = event;
        this.page_no = event.page + 1;
        this.limit = event.rows;
        // console.log(event);
        await this.get_count();
        if (this.totalRecords > 0) {
          this.get_list();
        }
      },
      get_count: function () {
        var data = {
          count: true,
          fullName: this.search_name,
        };
        this.loading = true;
        var promise = apis.FeedbackList(data, this.id);
        promise.then((response) => {
          this.loading = false;
          console.log(response);
          this.totalRecords = response.data.data;
          //alert(this.totalRecords);
        });
        console.log(data);
      },
      get_list: function () {
        var data = {
          Limit: this.limit,
          page_no: this.page_no,
          count: false,
          fullName: this.search_name,
        };
        this.loading = true;
        var promise = apis.FeedbackList(data, this.id);
        promise.then((response) => {
          this.loading = false;
          console.log(response);
          //this.products = Array.isArray(response.data.items) ? response.data.items : [];
          // this.products = response.data.data;
          this.products = response.data.data.map((item) => {
            // Map status values to human-readable strings
            return {
              ...item,
              status:
                item.status === 1
                  ? "Active"
                  : item.status === 2
                  ? "InActive"
                  : "Deleted",
            };
          });
          console.log("data", this.products);
          if (this.columns.length == 0) {
            if (this.products.length > 0) {
              this.columns = Object.keys(this.products[0]);
            }
          }
        });
        console.log(data);
      },
      formatCurrency(value) {
        if (value)
          return value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
        return;
      },
      openNew() {
        this.product = {};
        this.submitted = false;
        this.productDialog = true;
      },
      hideDialog() {
        this.productDialog = false;
        this.submitted = false;
      },
    saveProduct() {
        this.submitted = true;
        if (this.product.name.trim()) {
          if (this.product.id) {
            this.product.inventoryStatus = this.product.inventoryStatus.value
              ? this.product.inventoryStatus.value
              : this.product.inventoryStatus;
            this.products[this.findIndexById(this.product.id)] = this.product;
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: "Product Updated",
              life: 3000,
            });
          } else {
            this.product.id = this.createId();
            this.product.code = this.createId();
            this.product.image = "product-placeholder.svg";
            this.product.inventoryStatus = this.product.inventoryStatus
              ? this.product.inventoryStatus.value
              : "INSTOCK";
            this.products.push(this.product);
            this.$toast.add({
              severity: "success",
              summary: "Successful",
              detail: "Product Created",
              life: 3000,
            });
          }
          this.productDialog = false;
          this.product = {};
        }
      },
      editProduct(product) {
        this.file_attachment = "";
        this.product = { ...product };
        this.productDialog = true;
        //console.log("roledata",this.product);
        // this.selectstatus.value = this.product.type;
        // this.selectstatus.name = this.product.type;
        // this.selectstatus2.value = this.product.status;
        // this.selectstatus2.name = this.product.status;
        // this.file_attachment = this.product.image;
        if (this.product.status) {
          // Find the correct status object
          this.status =
            this.status_dropdownItems.find(
              (item) => item.name === this.product.status
            ) || null;
        }
      },
      confirmDeleteProduct(product) {
        this.product = product;
        this.deleteProductDialog = true;
      },
      deleteProduct() {
        this.products = this.products.filter((val) => val.id !== this.product.id);
        this.deleteProductDialog = false;
        this.product = {};
        this.$toast.add({
          severity: "success",
          summary: "Successful",
          detail: "Product Deleted",
          life: 3000,
        });
      },
      deleteVideo() {
        if (this.product.id) {
          var data = {
            Id: this.product.id,
          };
          this.isLoadingModel = true;
          var promise = apis.deletebatchmaster(data);
          promise.then((responseapi) => {
            this.isLoadingModel = false;
            if (responseapi.status == 200) {
              // this.hideDialog1();
              this.deleteProductDialog = false;
              this.$swal(responseapi.data);
              this.get_list();
              this.get_count();
            } else {
              this.$swal("error to Delete Video");
            }
          });
        }
      },
      findIndexById(id) {
        let index = -1;
        for (let i = 0; i < this.products.length; i++) {
          if (this.products[i].id === id) {
            index = i;
            break;
          }
        }
        return index;
      },
      createId() {
        let id = "";
        var chars =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 5; i++) {
          id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
      },
      exportCSV() {
        this.$refs.dt.exportCSV();
      },
      confirmDeleteSelected() {
        this.deleteProductsDialog = true;
      },
      deleteSelectedProducts() {
        this.products = this.products.filter(
          (val) => !this.selectedProducts.includes(val)
        );
        this.deleteProductsDialog = false;
        this.selectedProducts = null;
        this.$toast.add({
          severity: "success",
          summary: "Successful",
          detail: "Products Deleted",
          life: 3000,
        });
      },
      initFilters() {
        this.filters = {
          global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        };
      },
    },
    components: {},
  };
  </script>
  <style scoped lang="scss">
  @import "../assets/demo/badges.scss";
  </style>
  